import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { environment } from "../environment/environments";

const apiRoute = "/api/";

export const login = createAsyncThunk(
  "login/login",
  async ({rememberMe, obj}, thunkAPI) => {
    try {
      const remember = rememberMe ? rememberMe : ""
;
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          `login?rememberMe=${remember}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(obj),
        }
      );
      let data = await response.json();
      
      if (response.status === 200) {
        localStorage.setItem("userId", data.Data.id); 
        localStorage.setItem("role", data.Data.role?.id); 
        localStorage.setItem("pid", data.Data.programId); 
        localStorage.setItem("profileImg", data.Data.profileImg); 
        localStorage.setItem("name", data.Data.firstName + " " + data.Data.lastName); 
        localStorage.setItem("token", data.Token);

        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "login/forgotPassword",
  async ( obj, thunkAPI ) => {
    try {
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "forgotPassword",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(obj)
        }
      );
      let data = await response.json();
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const changeForgotPassword = createAsyncThunk(
  "login/changeForgotPassword",
  async ( {token, password}, thunkAPI ) => {
    try {
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "changeForgotPassword",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `user ${token}`,
          },
          body: JSON.stringify({password})
        }
      );
      let data = await response.json();
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getOrgTheme = createAsyncThunk(
  "login/getOrgTheme",
  async (subdomain, thunkAPI ) => {
    try {
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          subdomain +
          "/getOrgTheme",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          }
        }
      );
      let data = await response.json();
      
      if (response.status === 200) {
        localStorage.setItem("primaryColor",data?.Data?.primaryColorTheme);
        localStorage.setItem("logo",data?.Data?.logoUrl);
        // window.location.reload();
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);


export const userSlice = createSlice({
  name: "loginUser",
  initialState: {
    isFetching: false,
    isSuccess: false,
    forgotPassSuccess: false,
    isThemeFetched: false,
    isError: false,
    errorMessage: "",
    route: "",
    token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
    logo: localStorage.getItem('logo') ? localStorage.getItem('logo') : null,
    profileImg: localStorage.getItem('profileImg') ? localStorage.getItem('profileImg') : null,
    orgTheme: [],
  },
  reducers: {
    clearState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.forgotPassSuccess = false;
      state.isThemeFetched = false;
      state.isFetching = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(login.fulfilled, (state, { payload }) => {
        state.isFetching = false;
        state.isSuccess = true;
        state.route = payload?.role?.roleName
        state.logo = payload?.organization?.logoUrl;
        state.profileImg = payload?.profileImg;
    });
    builder.addCase(login.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(forgotPassword.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(forgotPassword.fulfilled, (state, { payload }) => {
        state.isFetching = false;
        state.forgotPassSuccess = true;
    });
    builder.addCase(forgotPassword.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(changeForgotPassword.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(changeForgotPassword.fulfilled, (state, { payload }) => {
        state.isFetching = false;
        state.isSuccess = true;
    });
    builder.addCase(changeForgotPassword.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
    builder.addCase(getOrgTheme.pending, (state) => {
        state.isFetching = true;
    });
    builder.addCase(getOrgTheme.fulfilled, (state, { payload }) => {
        state.isFetching = false;
        state.orgTheme = payload;
        state.isThemeFetched = true;
    });
    builder.addCase(getOrgTheme.rejected, (state, {payload}) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = payload?.Message ?? "Something went wrong!";
    });
  },
//   extraReducers: (builder) => {
//     builder.addCase(incrementBy, (state, action) => {
//       return state + action.payload
//     })
//     builder.addCase(decrementBy, (state, action) => {
//       return state - action.payload
//     })
//   },
});


export const { clearState } = userSlice.actions;

export const userSelector = (state) => state.user;